import styled from 'styled-components';

export const PageTitle = styled.h1`
  font-size: 27px;
  margin: 20px 0;
  color: #333;

  @media(max-width: 768px) {
    font-size: 22px;
    margin: 16px 0;
  }

  @media(max-width: 600px) {
    font-size: 20px;
    margin: 12px 4px;
    font-weight: 600;
  }

  @media(max-width: 480px) {
    font-size: 18px;
  }
`;